<p-dialog 
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  styleClass="loading-dialog-redesign"
  [style]="{ width: '350px', textAlign: 'center' }">

  <div class="content">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>

    <h3>{{ title }}</h3>
    <p *ngIf="message">{{ message }}</p>
  </div>
</p-dialog>
